import { Locale as DateFnsLocale } from "date-fns";
import { Locale as RcPickerLocale } from "rc-picker/lib/interface";
import { isTouchDevice } from "./utils";
import ErrorImg from "./assets/images/Error-person.svg";
import SuccessImg from "./assets/images/Success.svg";
import PendingImg from "./assets/images/Pending-person.svg";
// import locales
// made it this way, because cra webpack config imported all locales of all libs. As result there were 1000+ files each ~300B
// en
import dateFnsLocaleEn from "date-fns/locale/en-GB/index";
import rcPaginationLocaleEn from "rc-pagination/lib/locale/en_GB.js";
import rcPickerLocaleEn from "rc-picker/lib/locale/en_GB.js";
// nl
import dateFnsLocaleNl from "date-fns/locale/nl/index";
import rcPaginationLocaleNl from "rc-pagination/lib/locale/nl_BE.js";
import rcPickerLocaleNl from "rc-picker/lib/locale/nl_BE.js";

interface IAppConfig {
  isDevelopment: boolean;
  isProduction: boolean;
  isTouchDevice: boolean;
  apiUrl: string;
  publicUrl: string;
  defaultFaviconUrl: string;
  countdownDuration: number; // minutes
  responsive: {
    breakpointsExtension: "em" | "px"; // not used
    breakpoints: {
      name: "xs" | "sm" | "md" | "lg" | "xl";
      breakPoint: number; // first one always should be 0
    }[];
  };
  locales: {
    title: string; // display text in select
    key: string; // name of translation folder in public/locales/ (or from locize, to get available: https://docs.locize.com/integration/api#fetch-the-available-languages)
    flag: string; // take flag codes from https://github.com/madebybowtie/FlagKit/blob/master/Assets/Flags.md
    dateFnsLocale: DateFnsLocale;
    rcPaginationLocale: Record<string, unknown>;
    rcPickerLocale: RcPickerLocale;
    dinero: string;
    firstDayOfWeek: number;
  }[];
  locize: {
    projectId: string;
    apiKey: string;
  };
  translationFileNames: {
    base: string;
    steps: string;
    step_Main: string;
    step_Menu: string;
    step_Checkout: string;
    ff: string;
    paymentStatuses: string;
    react_day_picker: string;
  };
  paymentStatuses: {
    id: number;
    tKey: string;
    image: string;
    shouldKeepTrying?: boolean;
    btn?: {
      href?: string;
      restart?: boolean;
    };
  }[];
  reloadPaymentStatusDelay: number; // seconds
  maxDateRange: number;
  restrictPaymentSize: {
    max: number | null;
    min: number | null;
  };
  maxDaysInFutureDueDateMollie: number;
  paginationPerPage: number;
  forceReloadListItemsByTime: number;
  sections_sequence: string[];
}

const originUrl = window.location.origin;
const apiUrl = process.env.REACT_APP_DEV_API_URL;

const isDevelopment = process.env.NODE_ENV === "development";
const isProduction = process.env.NODE_ENV === "production";

export const AppConfig: IAppConfig = {
  isDevelopment: isDevelopment,
  isProduction: isProduction,
  isTouchDevice: isTouchDevice(),
  apiUrl: isDevelopment ? apiUrl ?? "/api" : originUrl + apiUrl,
  publicUrl: process.env.PUBLIC_URL,
  defaultFaviconUrl: "https://i.ibb.co/7404Xjw/default-Image.png",
  countdownDuration: 15,
  responsive: {
    breakpointsExtension: "em", // not used
    breakpoints: [
      {
        name: "xs",
        breakPoint: 0,
      },
      {
        name: "sm",
        breakPoint: 48, // in em's
      },
      {
        name: "md",
        breakPoint: 64,
      },
      {
        name: "lg",
        breakPoint: 75,
      },
      {
        name: "xl",
        breakPoint: 120,
      },
    ],
  },
  locales: [
    {
      title: "EN",
      key: "en",
      flag: "GB",
      dateFnsLocale: dateFnsLocaleEn,
      rcPaginationLocale: rcPaginationLocaleEn,
      rcPickerLocale: rcPickerLocaleEn,
      dinero: "en-EN",
      firstDayOfWeek: 1,
    },
    {
      title: "NL",
      key: "nl",
      flag: "NL",
      dateFnsLocale: dateFnsLocaleNl,
      rcPaginationLocale: rcPaginationLocaleNl,
      rcPickerLocale: rcPickerLocaleNl,
      dinero: "nl-BE",
      firstDayOfWeek: 1,
    },
  ],
  translationFileNames: {
    base: "base",
    steps: "steps",
    step_Main: "step_Main",
    step_Menu: "step_Menu",
    step_Checkout: "step_Checkout",
    ff: "ff",
    paymentStatuses: "paymentStatuses",
    react_day_picker: "react-day-picker",
  },
  locize: {
    projectId: "b4c45ace-1aec-41b0-bb0e-ee6bc8ec3013",
    apiKey: "91563b1b-9b8b-4c6b-ac47-bf1802bb829e",
  },
  paymentStatuses: [
    {
      id: 1,
      tKey: "NEW",
      image: ErrorImg,
    },
    {
      id: 2,
      tKey: "PENDING",
      image: PendingImg,
      shouldKeepTrying: true,
    },
    {
      id: 3,
      tKey: "CONFIRMED",
      image: SuccessImg,
      btn: {
        restart: true,
      },
    },
    {
      id: 4,
      tKey: "PREPAID",
      image: SuccessImg,
      btn: {
        restart: true,
      },
    },
    {
      id: 5,
      tKey: "EXPIRED",
      image: ErrorImg,
      btn: {
        restart: true,
      },
    },
    {
      id: 6,
      tKey: "CANCELLED",
      image: ErrorImg,
      btn: {
        restart: true,
      },
    },
    {
      id: 7,
      tKey: "COMPLETED",
      image: SuccessImg,
      btn: {
        restart: true,
      },
    },
    {
      id: 8,
      tKey: "REFUNDED",
      image: ErrorImg,
      btn: {
        restart: true,
      },
    },
  ],
  reloadPaymentStatusDelay: 5,
  maxDateRange: 1,
  restrictPaymentSize: {
    min: null,
    max: 1000000,
  },
  maxDaysInFutureDueDateMollie: 100,
  paginationPerPage: 3,
  forceReloadListItemsByTime: 600000, //every 10 minutes
  sections_sequence: ["activities", "packages"],
};
